import React from 'react';

const FaturaContext = React.createContext();

export default FaturaContext;
